export interface ApiValidation {
  PropertyName: string;
  ErrorMessage: string;
  AttemptedValue: object;
  CustomState: object;
  Severity: number;
  ErrorCode: string;
  FormattedMessagePlaceholderValues: object;
}
